import PortfolioModernContainer from "../../../../components/pages/portfolio/portfolioPage/PortfolioModern";

const PortfolioModern = () => {
  return <PortfolioModernContainer />;
};

export default PortfolioModern;
